// this is for meta description only. created from brooks seo doc much later

export const seoData = {
    'simple-tooth-extractions': {
        title: 'Simple Tooth Extractions | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Simple dental extraction involves the removal of teeth that are visible in the mouth. Our General dentists often carry out this procedure in our office.',
    },
    'lingual-braces': {
        title: 'Lingual Braces | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            "Lingual braces have the same components as conventional braces, but they're fixed to the back of your teeth, on the tongue.",
    },
    'after-tooth-extractions': {
        title: 'After Tooth Extractions | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'After 12 hours you may be able to gently rinse your mouth. Rinse 4 times a day with 1 teaspoon of salt in a glass of water. Check with your dentist first.',
    },
    'baby-bottle-tooth-decay': {
        title: 'Baby Bottle Tooth Decay | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Baby Bottle Tooth Decay most often occurs in the upper front teeth, but other teeth may also be affected. There are many factors which can cause tooth decay.',
    },
    appointments: {
        title: 'Kidz Dental Care SCV and PR - Appointments',
        description:
            'Kidz Dental Care Mission - Our mission is to provide optimum dental health care for infants, children and adolescents.',
    },
    'care-following-orthodontics-retainers': {
        title: 'Care Following Orthodontics – Retainers | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Ideally, you should clean them after every time you eat, so no food particles and bacteria become trapped between them and your teeth.',
    },
    'laser-teeth-whitening': {
        title: 'Laser Teeth Whitening | Santa Clarita, CA | Kidz Dental Care SCV and PR',
        description:
            'Laser teeth whitening is a cosmetic dental procedure that is available at Kidz Dental Care SCV and PR. Visit our website for more information.',
    },
    'an-introduction-to-braces': {
        title: 'An Introduction to Braces | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Braces work by placing a constant, gentle force upon the teeth in a carefully controlled direction. The braces slowly move the teeth to the correct position.',
    },
    'in-ovation-l-mtm': {
        title: 'In-Ovation® L MTM | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Complete treatment takes 12-24 weeks only. In-Ovation® treatment is cost-effective. Excellent results for patients needing less than 6mm of tooth movement.',
    },
    'pediatric-dentistry': {
        title: 'Pediatric Dentistry | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Welcome to Kidz Dental Care where your child will receive the best in pediatric dentistry.',
    },
    'tongue-piercing': {
        title: 'Tongue Piercing | Santa Clarita, California | Shukan C. Kanuga, DDS',
        description:
            'Unfortunately, tongue piercings can have a serious (even deadly) impact on health. Pediatric dentists routinely advise adolescents to avoid intraoral or perioral piercings for a number of good reasons.',
    },
    'home-care': {
        title: 'Home Care | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'A beautiful, healthy smile that lasts a lifetime is our ultimate goal when treating patients.Your personal home care plays an important role in achieving that goal.',
    },
    'is-it-ever-too-late-to-get-braces': {
        title: 'Is It Ever Too Late To Get Braces? | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Aside from the pleasing aesthetic of a beautifully straight smile, correcting malocclusion and teeth misalignment with braces is beneficial for a number of other reasons.',
    },
    'dental-anxiety-and-fear': {
        title: 'Dental Anxiety and Fear | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Dental anxiety and fear can become completely overwhelming. It is estimated that as many as 35 million people do not visit the dental office at all because they are too afraid.',
    },
    'new-patients': {
        title: 'Kidz Dental Care SCV and PR - New Patients',
        description: 'Contact our office today to give your child the healthy smile they need.',
    },
    'sedation-dentistry': {
        title: 'Pediatric Sedation Dentistry | Kidz Dental Care SCV and PR | Santa Clarita, CA',
        description:
            'We offer friendly pediatric sedation dentistry in Santa Clarita to address the fears and stresses of your children. Call today!',
    },
    'dental-videos': {
        title: 'Kidz Dental Care SCV and PR - Dental Videos',
        description:
            'Check out some of our helpful dental videos that are suited for people of all-ages.',
    },
    'financial-policy': {
        title: 'Kidz Dental Care SCV and PR - Financial Policy',
        description: 'Read our financial policy and see what insurances we accept.',
    },
    'hipaa-notice-of-privacy-practices': {
        title: 'Kidz Dental Care SCV and PR - HIPAA Notice of Privacy Practices',
        description:
            'This notice describes how medical information about you may be used and disclosed and how you can get access to this information.',
    },
    sealants: {
        title: 'Sealants | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'A sealant is a thin, plastic coating applied to the chewing surface of molars, premolars and any deep grooves (called pits and fissures) of teeth.',
    },
    'care-during-orthodontic-treatment': {
        title: 'Care During Orthodontic Treatment | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Taking care of braces properly and being committed to ideal results is an important part of orthodontic treatment.',
    },
    'how-to-properly-brush-and-floss': {
        title: 'How to Properly Brush & Floss | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Brushing and flossing are of paramount importance to oral hygiene. Though bi-annual professional dental cleanings remove plaque, tartar, and debris, excellent homecare methods are equally valuable.',
    },
    'what-is-a-malocclusion': {
        title: 'What is a Malocclusion? | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'A malocclusion is an incorrect relationship between the maxilla (upper arch) and the mandible (lower arch), or a general misalignment of the teeth.',
    },
    'special-needs-dentistry': {
        title: 'Special Needs Dentistry in Santa Clarita, CA | Kidz Dental Care SCV and PR',
        description:
            'We help children with special needs receive compassionate, comprehensive dental care. Visit to learn more!',
    },
    suresmile: {
        title: 'SureSmile® | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'The SureSmile® system offers quicker and more efficient treatment times than traditional dental braces. In fact, SureSmile braces can reduce the overall treatment times by as much as 40%.',
    },
    'care-for-your-childs-teeth': {
        title: 'Care for Your Child’s Teeth | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Pediatric oral care has two main components: preventative care at the pediatric dentist’s office and preventative care at home.',
    },
    'when-will-my-baby-start-getting-teeth': {
        title: 'When Will My Baby Start Getting Teeth? | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'In general, teeth emerge in pairs, starting at the front of the infant’s mouth. Between the ages of six and ten months, the two lower central incisors break through.',
    },
    'our-community': {
        title: 'Kidz Dental Care SCV and PR - Community',
        description:
            'Dr. Stephen Hirano and Dr. Shukan Kanuga and staff work closely with local schools. We are frequently invited to speak to children about oral hygiene and dental care.',
    },
    'pediatric-dental-appliances': {
        title: 'Pediatric Dental Appliances | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Though many parents think of “teenagers” when presented with the term “dental appliances,” the use of such appliances in young children is very common.',
    },
    'orthodontic-appliances': {
        description:
            'Learn about orthodontic appliances used to correct jaw alignment and reposition teeth. Explore types like palatal expanders, facemasks, and headgear for effective treatment.',
    },
    'tongue-and-lip-tie-laser-therapy': {
        title: 'Tongue and Lip Tie Laser Therapy | Santa Clarita & Valencia Dentist for Kids | Kidz Dental Care SCV and PR',
        description:
            'The development of excellent dental health, which includes teeth and tissue, is important to your child’s ability to properly breastfeed and establish clear speech.',
    },
    'early-orthodontic-treatment': {
        title: 'Early Orthodontic Treatment | Santa Clarita, California | Shukan C. Kanuga, DDS',
        description:
            'Orthodontic treatment is primarily used to prevent and correct “bite” irregularities.',
    },
    'xylitol-reducing-cavities': {
        title: 'Xylitol – Reducing Cavities | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Tooth decay is a common, yet preventable childhood problem. Left untreated, cavities in primary (baby) and permanent (adult) teeth become painful and negatively impact the esthetics and functionality of the teeth.',
    },
    'orthodontic-exams': {
        title: 'Orthodontic Exams | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'The planning stage is the most crucial phase in orthodontic treatment. During this phase, the orthodontist pinpoints a diagnosis and plans the most effective treatment.',
    },
    'dental-x-rays': {
        title: 'Dental X-Rays | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Dental radiographs (X-rays) are essential, preventative, diagnostic tools that provide valuable information not visible during a regular dental exam.',
    },
    'orthodontic-conditions': {
        title: 'Orthodontic Conditions | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Orthodontic irregularities stem from a variety of factors, which can include inherited traits and problems which developed from habits, such as thumb-sucking and tongue thrusting.',
    },
    'perinatal-and-infant-oral-health': {
        title: 'Perinatal and Infant Oral Health | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Pregnancy is an exciting time. It is also a crucially important time for the unborn child’s oral and overall health.',
    },
    'surgical-instructions': {
        title: 'Surgical Instructions | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'While most dental surgery is performed on an out-patient basis, it remains an involved procedure that requires specific preparation and aftercare.',
    },
    'what-is-orthodontics': {
        title: 'What is Orthodontics? | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Orthodontics is one of many dental specialties. The word “orthodontics” is derived from the Greek words orthos, meaning proper or straight and odons meaning teeth.',
    },
    'dental-radiographs-x-rays': {
        title: 'Dental Radiographs (X-Rays) | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Dental radiographs, also known as dental X-rays, are important diagnostic tools in pediatric dentistry. Dental radiographs allow the dentist to see and treat problems.',
    },
    'oral-maxillofacial-surgery': {
        title: 'Oral & Maxillofacial Surgery | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Dental radiographs, also known as dental X-rays, are important diagnostic tools in pediatric dentistry. Dental radiographs allow the dentist to see and treat problems.',
    },
    'orthodontic-treatment-phases-2': {
        title: 'Orthodontic Treatment Phases | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Orthodontic treatment is highly predictable and immensely successful. Depending on the severity of the malocclusion (bad bite) or irregularity, orthodontic treatments may occur in either two or three distinct phases.',
    },
    'does-your-child-grind-his-or-her-teeth-at-night': {
        title: 'Does Your Child Grind His or Her Teeth at Night? | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Bruxism, or the grinding of teeth, is remarkably common in children and adults. For some children, this tooth grinding is limited to daytime hours, but nighttime grinding (during sleep) is most prevalent.',
    },
    'orthodontic-dictionary': {
        title: 'Orthodontic Dictionary | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'The following are the most commonly used terms in orthodontics. If you have any questions about orthodontics or would like to schedule an appointment, please contact our office.',
    },
    'dental-exams-cleanings': {
        title: 'Dental Exams & Cleanings | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'A comprehensive dental exam will be performed by your dentist at your initial dental visit.',
    },
    'porter-ranch-forms': {
        title: 'Kidz Dental Care SCV and PR - Patient Information Forms',
        description:
            'Please fill out the secure patient information form below for our records before your first visit.',
    },
    'patient-information-form': {
        title: 'Kidz Dental Care SCV and PR - Patient Information Forms',
        description:
            'Please fill out the secure patient information form below for our records before your first visit.',
    },
    'sedation-dentistry-for-children': {
        title: 'Sedation Dentistry for Children | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Sedation dentistry helps you feel calm, relaxed, and at ease during dental procedures.',
    },
    treatment: {
        title: 'Treatment | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Periodontal treatment methods depend upon the type and severity of the disease. Your dentist and dental hygienist will evaluate for periodontal disease and recommend the appropriate treatment.',
    },
    'do-braces-hurt': {
        title: 'Do Braces Hurt? | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'There are two common types of fixed dental braces used to realign the teeth: ceramic fixed braces and metal fixed braces.',
    },
    'when-should-children-have-their-first-dental-visit': {
        title: 'When Should Children Have Their First Dental Visit? | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'The American Academy of Pediatric Dentistry (AAPD) suggests that parents should make an initial “well-baby” appointment with a pediatric dentist approximately six months after the emergence of the first tooth.',
    },
    'cephalometric-x-rays': {
        title: 'Cephalometric X-rays | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Cephalometric X-rays are an important diagnostic tool for orthodontic treatment planning.',
    },
    'causes-of-periodontal-disease': {
        title: 'Causes of Periodontal Disease | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'In fact, plaque buildup (which contains many kinds of bacteria) is the leading cause of gum disease.',
    },
    'at-home-care-for-orthodontic-soreness': {
        title: 'At-Home Care for Orthodontic Soreness | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Orthodontic soreness can be managed with simple at-home remedies such as rinsing with warm salt water or using orthodontic wax.',
    },
    'eating-while-wearing-braces': {
        title: 'Eating While Wearing Braces | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Traditional braces consist of bands, brackets, and wires, which are easily dislodged or damaged while eating. When orthodontic braces sustain damage, they cease to work in the intended way.',
    },
    'signs-symptoms-of-periodontal-disease': {
        title: 'Signs & Symptoms of Periodontal Disease | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'It is extremely important to note that periodontal disease can progress without any signs or symptoms such as pain.',
    },
    'other-procedures': {
        title: 'Kidz Dental Care SCV and PR - Procedures',
        description:
            'At Kidz Dental Care SCV and PR, we offer a full range of pediatric dental services and procedures.',
    },
    'whats-the-best-toothpaste-for-my-child': {
        title: 'What’s the Best Toothpaste for My Child? | Santa Clarita, California | Shukan C. Kanuga, DDS',
        description:
            'Selecting an appropriately sized toothbrush and a nourishing, cleansing brand of children’s toothpaste is of paramount importance for maintaining excellent oral health.',
    },
    'office-tour': {
        title: 'Kidz Dental Care SCV and PR - Office Tour',
        description: 'Take our virtual office tour to see our kid-friendly office.',
    },
    'for-parents': {
        title: 'Kidz Dental Care SCV and PR - For Parents',
        description:
            'We are happy to welcome you to our pediatric and general dentistry for children practice.',
    },
    'child-tooth-restorations': {
        title: 'Santa Clarita Pediatric Dental Crowns | Child Tooth Restorations',
        description:
            'Our advanced training and skills allow us to provide exceptional dental restorations for kids, including those with special needs, in Santa Clarita.',
    },
    restorations: {
        description:
            'Discover comprehensive dental restorations for kids in Santa Clarita. From tooth-colored fillings to crowns, we provide safe, amalgam-free treatments to restore your child’s healthy, confident smile.',
    },
    'repositioning-teeth-with-orthodontic-appliances': {
        title: 'Repositioning Teeth with Orthodontic Appliances | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Malocclusion (or bad bite) and teeth misalignment are extremely common and treatable problems for many individuals.',
    },
    'how-to-prevent-cavities': {
        title: 'How to Prevent Cavities | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Malocclusion (or bad bite) and teeth misalignment are extremely common and treatable problems for many individuals.',
    },
    'intraoral-cameras': {
        title: 'Intraoral Cameras | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description: 'Intraoral cameras are changing the face of routine dental appointments.',
    },
    'types-of-braces': {
        title: 'Types of Braces | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'There are many different types of orthodontic braces available. Each type, though made of varying components, realigns the teeth to enhance chewing, biting, and aesthetics.',
    },
    'what-is-an-orthodontist': {
        title: 'What is an Orthodontist? | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'There are many different types of orthodontic braces available. Each type, though made of varying components, realigns the teeth to enhance chewing, biting, and aesthetics.',
    },
    'who-can-benefit-from-orthodontics': {
        title: 'Who Can Benefit From Orthodontics? | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description: 'Orthodontists are experts in correcting misalignments of the teeth and jaw.',
    },
    'patient-reviews': {
        title: 'Kidz Dental Care SCV and PR - Patient Reviews',
        description: 'Check out our patient reviews.',
    },
    'orthodontic-emergencies': {
        title: 'Orthodontic Emergencies | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'If there is obvious damage to the wires, bands and brackets of your braces, it’s important to see your orthodontist as soon as possible.',
    },
    'mouth-body-connection': {
        title: 'Mouth - Body Connection | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Research studies have shown that there is a strong association between periodontal disease and other chronic conditions such as diabetes, heart disease, pregnancy complications and respiratory disease.',
    },
    'periodontal-disease': {
        title: 'Periodontal Disease | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'The word periodontal means “around the tooth". Periodontal disease attacks the gums and the bone that support the teeth.',
    },
    'composite-fillings': {
        title: 'Composite Fillings | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'A composite (tooth colored) filling is used to repair a tooth that is affected by decay, cracks, fractures, etc. The decayed or affected portion of the tooth will be removed and then filled with a composite filling.',
    },
    '6-month-smiles': {
        title: '6 Month Smiles® | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Six Month Smiles is a clear braces system designed to straighten your teeth in approximately 6 months. Generally less expensive than traditional braces.',
    },
    'tobacco-use': {
        title: 'Tobacco Use | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Tobacco use is one of the leading causes of death in society. Fortunately, it is also among the most preventable.',
    },
    'orthodontic-treatment-braces': {
        title: 'Orthodontic Treatment (Braces) | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'The benefits of orthodontic treatment often go beyond the obvious physical changes of an improved bite and straighter teeth.',
    },
    'when-should-my-child-get-an-orthodontic-evaluation': {
        title: 'When Should My Child Get An Orthodontic Evaluation? | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Orthodontists aim to prevent and treat irregularities in the jaw and misalignment of the teeth that are the result of genetics, or develop in accordance with a child’s habits.',
    },
    'how-often-should-children-have-dental-checkups': {
        title: 'How Often Should Children Have Dental Checkups? | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'The American Academy of Pediatric Dentists (AAPD) advises parents to make biannual dental appointments for children, beginning approximately six months after the first tooth emerges.',
    },
    'meet-the-doctor': {
        title: 'Shukan C. Kanuga, DDS - Meet The Doctor',
        description:
            'Dr. Kanuga completed her Pediatric dentistry training with a MSD degree from one of the most esteemed programs at the University of Washington, Seattle in 2009.',
    },
    'procedure-financing': {
        title: 'Financing | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'We are pleased to accept the CareCredit healthcare, credit card. CareCredit lets you say "Yes" to recommended surgical and non-surgical dental procedures like crowns, oral surgery or even a general checkup.',
    },
    'panoramic-x-rays': {
        title: 'Panoramic X-rays | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Panoramic X-rays (also known as Panorex® or orthopantomograms) are wraparound photographs of the face and teeth.',
    },
    'braces-for-adults': {
        title: 'Braces for Adults | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Orthodontic braces are predictable, versatile, and incredibly successful at realigning the teeth. Braces work in the same way regardless of the age of the patient.',
    },
    'before-general-anesthesia': {
        title: 'Before General Anesthesia | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Prior to your dental surgery you will have the opportunity to address any concerns you might have during your pre-op appointment.',
    },
    'braces-for-children': {
        title: 'Braces for Children | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Many children are ambivalent about getting braces. On one hand, they like the idea of perfect teeth, but on the other hand, they are nervous about whether the braces will cause pain and discomfort.',
    },
    'pacifiers-and-thumb-sucking': {
        title: 'Pacifiers and Thumb Sucking | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'In most cases, children naturally relinquish the pacifier or thumb over time. As children grow, they develop new ways to self-soothe, relax, and entertain themselves.',
    },
    'orthodontic-treatment-phases': {
        title: 'Orthodontic Treatment Phases | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Orthodontic irregularities are extremely common and vary in their complexity. In the case of a severe irregularity, the orthodontist may work in conjunction with a maxillofacial surgeon.',
    },
    'mouth-guards': {
        title: 'Mouth Guards | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Mouth guards, also known as sports guards or athletic mouth protectors, are crucial pieces of equipment for any child participating in potentially injurious recreational or sporting activities.',
    },
    testimonials: {
        title: 'Kidz Dental Care SCV and PR - Testimonials',
        description: 'See our wonderful testimonials.',
    },
    'why-see-a-pediatric-dentist': {
        title: 'Why See a Pediatric Dentist? | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Prior to your dental surgery you will have the opportunity to address any concerns you might have during your pre-op appointment.',
    },
    'digital-x-rays': {
        title: 'Digital X-Rays | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Dental X-rays are essential, preventative, diagnostic tools that provide valuable information not visible during a regular dental exam.',
    },
    'sippy-cups': {
        title: 'Sippy Cups | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Many pediatric dentists believe that frequent, prolonged sippy cup use contributes to toddler tooth decay. Sippy cups are an excellent tool to help ease the transition between baby bottles.',
    },
    'eruption-of-your-childs-teeth': {
        title: 'Eruption of Your Child’s Teeth | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'The eruption of primary teeth (also known as deciduous or baby teeth) follows a similar developmental timeline for most children.',
    },
    'good-diet': {
        title: 'Good Diet | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'A child’s general level of health often dictates his or her oral health, and vice versa. Therefore, supplying children with a well-balanced diet is more likely to produce healthier teeth and gums.',
    },
    'why-are-primary-teeth-important': {
        title: 'Why Are Primary Teeth Important? | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Primary teeth, also known as “baby teeth" or “deciduous teeth," begin to develop beneath the gums during the second trimester of pregnancy.',
    },
    'what-is-pulp-therapy': {
        title: 'What is Pulp Therapy? | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'The “pulp" of a tooth cannot be seen with the naked eye. Pulp is found at the center of each tooth, and is comprised of nerves, tissue, and many blood vessels, which work to channel vital nutrients and oxygen.',
    },
    'sealing-out-tooth-decay': {
        title: 'Sealing Out Tooth Decay | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Kidz Dental Care Mission - Our mission is to provide optimum dental health care for infants, children and adolescents and provide a lifetime of beautiful smiles. We believe all children are special and look forward to being an integral part of your child’s life. We strive to eliminate the fear associated with dental visits by providing gentle care in a fun, relaxed, kid-friendly atmosphere. We want to foster an appreciation of good oral health. We welcome the opportunity to help your child formulate a lifetime of healthy dental habits.',
    },
    'contact-us': {
        title: 'Kidz Dental Care SCV and PR - Contact Us',
        description: 'Contact our team to take care of your children’s dental needs.',
    },
    'brushing-and-flossing-with-braces': {
        title: 'Brushing and Flossing with Braces | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description: 'Make sure your children brush and floss their teeth before bed each night.',
    },
    'root-canal-therapy': {
        title: 'Root Canal Therapy | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Having a root canal done on a tooth is the treatment of choice to save a tooth that otherwise would die and have to be removed.',
    },
    maintenance: {
        title: 'Maintenance | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'It only takes twenty-four hours for plaque that is not removed from your teeth to turn into calculus (tartar)!',
    },
    'what-does-orthodontic-treatment-involve': {
        title: 'What Does Orthodontic Treatment Involve? | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Orthodontics is a highly-specialized branch of dentistry that deals with facial and jaw irregularities.',
    },
    'fluoride-treatments': {
        title: 'Fluoride Treatment | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Fluoride is the most effective agent available to help prevent tooth decay. It is a mineral that is naturally present in varying amounts in almost all foods and water supplies.',
    },
    'oral-pathology': {
        title: 'Oral Pathology | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'An oral exam is routinely performed by the dentist during the course of an initial comprehensive exam and regular check-ups.',
    },
    fluoride: {
        title: 'Fluoride | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Fluorine, a natural element in the fluoride compound, has proven to be effective in minimizing childhood cavities and tooth decay.',
    },
    invisalign: {
        title: 'Invisalign® | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'One of the primary concerns people often have about dental braces is the aesthetic impact of the metalwork on their smile.',
    },
    'why-straighten-teeth': {
        title: 'Why Straighten Teeth? | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Straighter teeth perform chewing, biting and speaking functions more effectively than crooked teeth. In addition, a straight smile boosts confidence.',
    },
    'first-visit': {
        title: 'First Visit | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'According to AAPD (American Academy of Pediatric Dentistry) guidelines, infants should initially visit the pediatric dentist around the time of their first birthday.',
    },
    diagnosis: {
        title: 'Diagnosis | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Periodontal disease is diagnosed by your dentist or dental hygienist during a periodontal examination. This type of exam should always be part of your regular dental check-up.',
    },
    'digital-radiographs': {
        title: 'Digital Radiographs | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Digital radiographs (x-rays) are an important diagnostic tool for dental professionals.',
    },
    'does-my-child-need-early-orthodontics': {
        title: 'Does My Child Need Early Orthodontics? | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Orthodontic problems can sometimes be invisible to the untrained eye. An orthodontist is highly skilled at detecting the smallest clues of irregularities and misalignment.',
    },
    'cleanings-prevention': {
        title: 'Dental Cleaning & Prevention in Santa Clarita, CA | Kidz Dental Care SCV and PR',
        description:
            'Following a daily routine of brushing and flossing is a great habit, but it still does not replace the need for regular professional dental cleanings and examinations.',
    },
    'crowns-caps': {
        title: 'Crowns (Caps) | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'A crown (or cap) is a covering that encases the entire tooth surface, restoring it to its original shape and size.',
    },
    'tooth-extractions': {
        title: 'Tooth Extractions | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Tooth extractions, or the removal of one or more teeth, are usually used as a last resort in dentistry, as keeping the natural tooth in the mouth is ideal.',
    },
    'damon-braces': {
        title: 'Damon® Braces | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'What is a Damon Smile? Unlike conventional braces, the Damon System uses gentle forces designed to protect the health of your teeth and gums while in treatment.',
    },
    'oral-hygiene-aids': {
        title: 'Oral Hygiene Aids | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'The rubber tip stimulator is an excellent tool for removing plaque from around the gum line and also for stimulating blood flow to the gums.',
    },
    orthodontics: {
        title: 'Orthodontics | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Orthodontics is a branch of dentistry specializing in the diagnosis, prevention, and treatment of jaw, face and bite irregularities (malocclusions*).',
    },
    'dental-emergencies': {
        title: 'Dental Emergencies | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Although dental injuries and dental emergencies are often distressing for both children and parents, they are also extremely common.',
    },
    'meet-our-staff': {
        title: 'Kidz Dental Care SCV and PR - Meet Our Staff',
        description:
            'We have a friendly team at Kidz Dental Care different branches. Contact our office today to schedule your appointment!',
    },
    'meet-the-doctors': {
        title: 'Kidz Dental Care SCV and PR - Meet The Doctors',
        description:
            'Dr. Kanuga, Dr. Hirano, and the friendly team at Kidz Dental Care are here for the dental care of your family. Contact our office today to schedule your appointment!',
    },
    'caring-for-athletic-mouth-guards': {
        title: 'Caring for Athletic Mouth Guards | Santa Clarita, California | Kidz Dental Care SCV and PR',
        description:
            'Mouth guards are often overlooked as a part of sports equipment, but patients who use them are up to sixty times less likely to suffer oral injuries compared to those who don’t.',
    },
    'patient-resources': {
        description:
            "Explore our comprehensive patient resources at Kidz Dental Care. Access helpful information, forms, and guides to ensure your child's dental health journey is smooth and stress-free.",
    },
    'payment-options-and-arrangements-form': {
        description:
            'Learn about the payment options and arrangements available at Kidz Dental Care. We strive to make dental care accessible and affordable for all families. Contact us for more details.',
    },
};
